import React from 'react';
import { Virtual } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import { OVERLAYS_URL } from '../../../Settings';
import {
    playersWithAttackableLodging,
} from '../../Game/GamePlayerInfo';
import {
    getFactionTextureUrl,
} from '../../TwoD/Common/TextureTools';

import '../../TwoD/Components/Controls/Actions/action-scroller.css';
import './ActionAttack.css';

const OVERLAY_TARGETING = OVERLAYS_URL
    + 'TargetingOverlay-1080x210.png';

// ActionAttack — verbatim port of LodgingActionJuice's targets
// sub-section. Per-row anchor `<div id="targets">` with an `<img
// className="swiper-overlay" style={{opacity:'50%'}}>` over the
// Swiper. Target list built by the candidate-picker fn (defaults to
// playersWithAttackableLodging so existing Lodging callsites are
// unchanged) and mapped into { id, seat, name, src } — matches the
// source's getTargets. Ghost passes playersWithGhostableDocks.
export function ActionAttack({
    gamePlayerData, gameData, onTargetClick,
    pickCandidates = playersWithAttackableLodging,
}) {
    let targets = [];
    if (gameData && gamePlayerData) {
        try {
            const players = pickCandidates(gameData, gamePlayerData);
            targets = players.map((gp) => ({
                id: gp.id,
                seat: gp.seat,
                name: gp.name,
                src: getFactionTextureUrl(gp.faction),
            }));
        } catch (_err) {
            targets = [];
        }
    }

    const handleTargetClick = (playerId) => {
        if (typeof onTargetClick === 'function') onTargetClick(playerId);
    };

    return (
        <div className={'action-attack-anchor'}
             id={'targets'}
             data-testid={'action-attack'}>
            <img src={OVERLAY_TARGETING}
                 alt={'action'}
                 data-testid={'action-attack-overlay'}
                 className={'swiper-overlay'}
                 style={{ opacity: '50%' }}/>
            <Swiper slidesPerView={6}
                    spaceBetween={0}
                    modules={[Virtual]}
                    className={'action-scroller-swiper'}>
                {targets.map((target, index) => (
                    <SwiperSlide key={'target-' + index}
                                 virtualIndex={index}>
                        <div className={'action-attack-target'}
                             data-testid={'action-attack-target'}
                             data-player-id={target.id}
                             title={'Target ' + target.name
                                 + ' in Seat ' + target.seat}
                             onClick={() =>
                                 handleTargetClick(target.id)}>
                            <img src={target.src}
                                 alt={'target'}/>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

export default ActionAttack;
